import axios from 'axios';
import actions from './actions';
import config from '../../../../config/index';

const getBankVerificationInitialDataAction = actions.Creators.getBankVerificationInitialData;

const getBankVerificationInitialData = (submissionUuid) => async dispatch => {
	try {
		const response = await axios.get(
            `${config.apiUrl}/fundingPlatformPublic/bankVerification/getInitialData/${submissionUuid}`
        );
        let account = response.data.account;
        let opportunity = response.data.opportunity;
        let link_token = response.data.plaidToken.link_token;
		const data = { account, opportunity, submissionUuid, link_token };
		
        dispatch(getBankVerificationInitialDataAction(data));
		return data; // Return data so componentDidMount can read it directly
	}
	catch(error) {
		console.error('Failed to fetch initial data:', error);
        // Do NOT dispatch raw error. Dispatch a formatted action if needed:
        // dispatch({ type: 'GET_BANK_VERIFICATION_ERROR', error });	
	}
	// return;
}

const getTransactions = async (token, metadata) => {
	try {
		await axios.post(config.apiUrl + '/fundingPlatformPublic/bankVerification/getTransactions', { token: token, metadata: metadata});
	}
	catch(error) {
		console.error(error);
	}
	return;
}

const getBankData = async (linkedBanks, accountUuid, opportunityUuid) => {
	let linkedBanksArray = linkedBanks.map( linkedBank => {
		return { publicToken: linkedBank.token, institutionName: linkedBank.metadata.institution.name};
	});
	try {
	await axios.post(config.apiUrl + '/fundingPlatformPublic/bankVerification/getBankData', {linkedBanks: linkedBanksArray, accountUuid, opportunityUuid});
	}
	catch(error) {
		console.error(error);
	}
	return;
}

export default {
    getBankVerificationInitialData,
    getTransactions,
    getBankData
  }